// Version 4: Versionsnummer der Website, steht klein in der Fußzeile.
// Bei jeder ausgelieferten Änderung hochzählen (2.0, 2.1, 2.2 …), große neue Fassung 3.0.
export const SITE_VERSION = "2.44";
